<template>
	<div class="row content-block">
		<div class="col-12 col-lg-12">
			<div class="single-image">
				<img :src="this.image_data.default_image_url" :alt="this.image_data.attributes.caption">
				<div v-if="this.image_data.attributes.caption !== ''" class="image-caption">
					{{ this.image_data.attributes.caption }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ContentImage',
	props: [
		'image_data',
		'static_content',
		'block_title',
		'fetchedData',
	],
};
</script>
